<template>
    <ui-card class="content">
        <p><i class="far fa-fw fa-briefcase mr-3"></i>Contracted Work Schedule</p>

        <div class="has-text-centered py-2" v-if="isLoading">
            <i class="fas fa-spin fa-spinner fa-fw mr-2"></i>Loading schedule...
        </div>

        <template v-else>
            <p class="is-size-7 has-text-grey-dark ml-3">
                The hours you're contracted to work each week. Study time may not be logged during
                these hours; time logged inside your contracted schedule is flagged for review.
            </p>

            <div class="ml-3" v-if="schedule && schedule.declared">
                <div class="has-text-weight-bold">{{ summary }}<template v-if="contractYearLabel"> &middot; {{ contractYearLabel }}</template></div>
                <div class="is-size-7 has-text-grey">
                    Declared {{ schedule.effective_from | moment('MMMM Do, YYYY') }} &middot; changes apply going forward
                </div>
            </div>
            <div class="ml-3" v-else>
                <div class="has-text-weight-bold">Not declared yet</div>
            </div>

            <b-button type="is-info" size="is-small" class="ml-3 mt-3" @click="modalOpen = true">
                <i class="fas fa-pen mr-2"></i>{{ schedule && schedule.declared ? 'Update Schedule' : 'Declare Schedule' }}
            </b-button>

            <contracted-schedule-modal :active.sync="modalOpen" :schedule="schedule" @saved="onSaved"/>
        </template>
    </ui-card>
</template>

<script>
import {axiosInstance as http} from '@/http_client';
import UiCard from '@/components/UiCard';
import ContractedScheduleModal from './ContractedScheduleModal';
import {summarizeSchedule, fmtContractYear} from './scheduleUtil';

export default {
    name: 'ContractedScheduleCard',
    components: {UiCard, ContractedScheduleModal},
    data() {
        return {
            isLoading: true,
            schedule: null,
            modalOpen: false,
        };
    },
    computed: {
        summary() {
            return summarizeSchedule(this.schedule && this.schedule.blocks);
        },
        contractYearLabel() {
            return fmtContractYear(this.schedule && this.schedule.year_start, this.schedule && this.schedule.year_end);
        },
    },
    async mounted() {
        try {
            const {data} = await http.get('app/study-activity/schedule');
            this.schedule = data;
        } catch (err) {
            this.schedule = null;
        }
        this.isLoading = false;
    },
    methods: {
        onSaved(schedule) {
            this.schedule = schedule;
        },
    },
};
</script>
